/* eslint-disable import/prefer-default-export */
// import icon

export const airmasterConfig = {
  title: 'AMS',
  catalog: 'partner',
  partner: 'airmaster',
  origin: 'https://airmastersystems.com',
  host: 'https://chairs.airmastersystems.com',
  logo: 'https://ecomseating.s3.us-east-1.amazonaws.com/images/other/airmaster.png',
  logoURL: 'https://ecomseating.s3.us-east-1.amazonaws.com/images/other/airmaster.png',
  buildAChair: 'airmaster',
  businessInfo: '6480 Norton Center Dr, Muskegon, MI 49441',
  headerTheme: '#f8f8f8',
  secondaryTheme: '#2d5c88',
  footerTheme: '#2d5c88',
  headerTextColor: '#49618f',
  footerTextColor: '#FFFFFF',
  buttonTextColor: '#FFFFFF',
  extraAttributes: {
    trackId: '0000',
    icon: null,
  },
};
